import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout";
import { useParams } from "react-router-dom";
import "./Sheet.css";

type User = {
  id: number;
  last_name: string;
  first_name: string;
  last_name_en: string;
  first_name_en: string;
  name_ini: string;
  name: string;
  name_en: string;
  nationality: string;
  gender: string;
  age: number;
  birth_date: string;
  current_address: string;
  qualifications?: {
    id: string;
    name: string;
    pivot: {
      qualification_id: number;
      qualification_get_date: string;
    };
  }[];
  sheets: {
    updated_at: string;
  };
  isSelected: boolean;
  isTarget: boolean;
};

type Qualification = {
  id: string | "";
  qualification_id: string | null;
  name: string | null;
  get_date: string | null;
  isDisplay: boolean;
};

type Specialty = {
  sheet_id: number;
  specialty: string;
};

type TechFolio = {
  id: string | null;
  specialty: string;
  tech_experiences?: {
    id: string | null;
    skill_type: number;
    sequence_num: number;
    industry: string;
    system_name: string;
    system_detail: string;
    assigned_task: string;
    work_contents?: {
      id: number;
      name: string;
    }[];
    position_id: number | null;
    position?: {
      id: string | null;
      name: string;
    };
    team: string;
    member_count: string;
    env1: string;
    env2: string;
    env3: string;
    env4: string;
    env5: string;
    work_start_period: string;
    work_end_period: string;
    period_year: number | null;
    period_month: number | null;
    client: string;
    end_user: string;
    remarks: string;
  }[];
};

type WorkContent = {
  id: number;
  experience_id: number;
  work_content_id: number;
};

// 技術経験シート中の作業内容と役割の選択肢の型定義
type SelectOption = {
  id: number;
  name: string;
};

const MySheet: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [qualificationOptions, setQualificationOptions] = useState<
    SelectOption[]
  >([]);
  const [qualifications, setQualifications] = useState<Qualification[]>([]);
  const [techFolio, setTechFolio] = useState<TechFolio | null>(null);
  const [workContentOptions, setWorkContentOptions] = useState<SelectOption[]>(
    [],
  );
  const [positionOptions, setPositionOptions] = useState<SelectOption[]>([]);
  const { userId } = useParams();

  const testTechFolioApp: TechFolio = {
    id: "1",
    specialty: `Webアプリケーション開発(Java+SpringBoot、Ruby+RubyonRails)、BootStrap、Sass
Androidアプリケーション開発(Java)、PHP、JavaScript
要件～基本設計などの上流工程、バックエンドのテーブル設計`,
    tech_experiences: [
      {
        id: "1",
        sequence_num: 1,
        skill_type: 1,
        industry: "大学在学中",
        system_name: "大学のバス時刻表検索システム",
        system_detail:
          "(PHP+MySQL)を使用して大学のバス時刻表検索システムの開発",
        assigned_task: "フロントエンド実装・単体テスト",
        work_contents: [
          { id: 1, name: "要件定義" },
          { id: 2, name: "基本設計" },
          { id: 3, name: "ＣＤ・ＵＴ" },
        ],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "PJTチーム",
        member_count: "4",
        env1: "MacOS",
        env2: "-",
        env3: "PHP MySQL",
        env4: "MySQL",
        env5: "Xcode",
        work_start_period: "2020-01",
        work_end_period: "2021-06",
        period_year: 1,
        period_month: 7,
        client: "",
        end_user: "",
        remarks: "",
      },
      {
        id: "2",
        sequence_num: 2,
        skill_type: 1,
        industry: "社内研修",
        system_name: "顔認証入退室システム",
        system_detail: "---概要を記載---",
        assigned_task: "画面周り／API連携",
        work_contents: [
          { id: 1, name: "ＣＤ・ＵＴ" },
          { id: 2, name: "ＣＤ・ＵＴ" },
        ],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "6",
        env1: "Linux",
        env2: "Jenkins, Git",
        env3: "C#",
        env4: "SQL Server",
        env5: "Visual Studio",
        work_start_period: "2019-04",
        work_end_period: "2020-03",
        period_year: 1,
        period_month: 0,
        client: "",
        end_user: "",
        remarks: "",
      },
      {
        id: "3",
        sequence_num: 3,
        skill_type: 1,
        industry: "",
        system_name: "",
        system_detail:
          "アイソプラへ転職する前に、他社でIT関連の業務をやっていた場合は記載。",
        assigned_task: "",
        work_contents: [],
        position_id: null,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "",
        env1: "",
        env2: "",
        env3: "",
        env4: "",
        env5: "",
        work_start_period: "2021-01",
        work_end_period: "2021-12",
        period_year: 1,
        period_month: 0,
        client: "",
        end_user: "",
        remarks: "",
      },
      {
        id: "4",
        sequence_num: 4,
        skill_type: 1,
        industry: "ゲーム",
        system_name: "スマートフォン向けゲームアプリ",
        system_detail: "カジュアルゲームのQA・テストを担当",
        assigned_task: "テスト実施・不具合報告",
        work_contents: [
          { id: 3, name: "ＣＤ・ＵＴ" },
          { id: 5, name: "システムテスト" },
        ],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "PJTチーム",
        member_count: "3",
        env1: "Android",
        env2: "Redmine, Excel",
        env3: "-",
        env4: "-",
        env5: "Android Studio",
        work_start_period: "2019-01",
        work_end_period: "2019-06",
        period_year: 0,
        period_month: 6,
        client: "ゲーム会社G",
        end_user: "スマホアプリ利用者",
        remarks: "再現性確認や報告資料作成も対応",
      },
      {
        id: "5",
        sequence_num: 5,
        skill_type: 1,
        industry: "物流",
        system_name: "配送計画支援システム",
        system_detail: "最適な配送ルートを自動計算しドライバーに提示",
        assigned_task: "詳細設計、結合テスト",
        work_contents: [{ id: 4, name: "結合テスト" }],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "PJTチーム",
        member_count: "7",
        env1: "Windows Server",
        env2: "Redmine",
        env3: "Java",
        env4: "Oracle",
        env5: "IntelliJ",
        work_start_period: "2017-03",
        work_end_period: "2018-03",
        period_year: 1,
        period_month: 1,
        client: "物流会社Z",
        end_user: "ドライバー",
        remarks: "地図連携に苦労",
      },
      {
        id: "6",
        sequence_num: 6,
        skill_type: 1,
        industry: "小売",
        system_name: "ECサイト構築",
        system_detail: "自社ブランド製品のネット販売サイト構築",
        assigned_task: "フロント実装、テスト",
        work_contents: [{ id: 2, name: "基本設計" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "3",
        env1: "Linux",
        env2: "Git, Docker",
        env3: "PHP, JavaScript",
        env4: "MySQL",
        env5: "VSCode",
        work_start_period: "2022-02",
        work_end_period: "2022-10",
        period_year: 0,
        period_month: 9,
        client: "小売店C",
        end_user: "一般消費者",
        remarks: "レスポンシブ対応あり",
      },
      {
        id: "7",
        sequence_num: 7,
        skill_type: 1,
        industry: "官公庁",
        system_name: "住民情報管理システム",
        system_detail: "住民票、戸籍などの情報を統合管理",
        assigned_task: "調査分析、要件定義",
        work_contents: [{ id: 8, name: "調査分析" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "10",
        env1: "Windows",
        env2: "Redmine",
        env3: "Java",
        env4: "Oracle",
        env5: "Eclipse",
        work_start_period: "2016-04",
        work_end_period: "2017-04",
        period_year: 1,
        period_month: 1,
        client: "市役所A",
        end_user: "住民窓口",
        remarks: "法制度改正への対応",
      },
      {
        id: "8",
        sequence_num: 8,
        skill_type: 1,
        industry: "エンタメ",
        system_name: "動画配信プラットフォーム",
        system_detail: "映画・アニメのストリーミングサービス開発",
        assigned_task: "バックエンドAPI設計・開発",
        work_contents: [{ id: 3, name: "ＣＤ・ＵＴ" }],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "PJTチーム",
        member_count: "5",
        env1: "Linux",
        env2: "Git, Jenkins",
        env3: "Node.js",
        env4: "MongoDB",
        env5: "WebStorm",
        work_start_period: "2020-07",
        work_end_period: "2021-06",
        period_year: 1,
        period_month: 0,
        client: "動画配信会社",
        end_user: "登録ユーザー",
        remarks: "トラフィック負荷テスト実施",
      },
      {
        id: "9",
        sequence_num: 9,
        skill_type: 1,
        industry: "不動産",
        system_name: "物件情報管理システム",
        system_detail: "物件情報の登録・検索・閲覧機能",
        assigned_task: "UI設計・画面実装",
        work_contents: [{ id: 6, name: "画面設計" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "4",
        env1: "MacOS",
        env2: "Figma, Git",
        env3: "TypeScript, React",
        env4: "MySQL",
        env5: "VSCode",
        work_start_period: "2021-08",
        work_end_period: "2022-06",
        period_year: 0,
        period_month: 11,
        client: "不動産仲介業B",
        end_user: "営業担当者",
        remarks: "アクセシビリティ対応",
      },
      {
        id: "10",
        sequence_num: 10,
        skill_type: 1,
        industry: "通信",
        system_name: "チャット・通話アプリ",
        system_detail: "リアルタイムチャットと音声通話の実装",
        assigned_task: "要件定義、API開発",
        work_contents: [{ id: 1, name: "要件定義" }],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "PJTチーム",
        member_count: "6",
        env1: "Linux",
        env2: "Git, Docker",
        env3: "Go, Vue.js",
        env4: "PostgreSQL",
        env5: "IntelliJ",
        work_start_period: "2022-01",
        work_end_period: "2022-12",
        period_year: 1,
        period_month: 0,
        client: "通信会社Z",
        end_user: "アプリユーザー",
        remarks: "WebRTC導入済",
      },
    ],
  };

  const testTechFolioSecurity: TechFolio = {
    id: "4",
    specialty: `セキュリティポリシー策定、脆弱性診断、アクセス制御、暗号化技術の導入など、セキュリティ対策全般に対応可能。SOC運用経験あり。`,
    tech_experiences: [
      {
        id: "1",
        sequence_num: 1,
        skill_type: 3,
        industry: "行政",
        system_name: "地方自治体セキュリティサポート",
        system_detail:
          "Tanium運用支援\n対象モジュール: Interact, Connect, Discover, Deploy, Patch",
        assigned_task: "運用担当者からの問い合わせ対応",
        work_contents: [{ id: 8, name: "調査分析" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "セキュリティ診断チーム",
        member_count: "4",
        env1: "Tanium",
        env2: "オンプレ",
        env3: "Windows, Linux",
        env4: "",
        env5: "",
        work_start_period: "2022-03",
        work_end_period: "2022-08",
        period_year: 0,
        period_month: 6,
        client: "地方都市A",
        end_user: "セキュリティ担当部署",
        remarks: "CSIRTへの報告も対応",
      },
      {
        id: "2",
        sequence_num: 2,
        skill_type: 3,
        industry: "製造業",
        system_name: "資産管理システム導入支援",
        system_detail:
          "Tanium Cloud導入支援\n対象モジュール: Core, Patch, Deploy",
        assigned_task: "ドキュメント作成、パラメータ設計、テスト",
        work_contents: [{ id: 2, name: "基本設計" }],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "セキュリティ統制チーム",
        member_count: "3",
        env1: "Tanium Cloud",
        env2: "クラウド",
        env3: "Windows",
        env4: "",
        env5: "",
        work_start_period: "2023-04",
        work_end_period: "2023-10",
        period_year: 0,
        period_month: 7,
        client: "製造業B",
        end_user: "社内システムユーザー",
        remarks: "外部委託先向けVPN制限も実施",
      },
      {
        id: "3",
        sequence_num: 3,
        skill_type: 3,
        industry: "",
        system_name: "",
        system_detail:
          "アイソプラへ転職する前に、他社でIT関連の業務をやっていた場合は記載。",
        assigned_task: "",
        work_contents: [],
        position_id: null,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "",
        env1: "",
        env2: "",
        env3: "",
        env4: "",
        env5: "",
        work_start_period: "2024-01",
        work_end_period: "2024-12",
        period_year: 1,
        period_month: 0,
        client: "",
        end_user: "",
        remarks: "",
      },
      {
        id: "4",
        sequence_num: 4,
        skill_type: 3,
        industry: "小売",
        system_name: "クレジット決済環境の暗号化対応",
        system_detail: "通信およびDBの暗号化対応を実施（PCI-DSS）",
        assigned_task: "暗号化方式の選定と導入支援",
        work_contents: [{ id: 1, name: "要件定義" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "セキュリティ設計チーム",
        member_count: "5",
        env1: "AWS KMS",
        env2: "IAM制御",
        env3: "アクセスログ",
        env4: "",
        env5: "",
        work_start_period: "2023-09",
        work_end_period: "2024-03",
        period_year: 0,
        period_month: 7,
        client: "小売チェーンC",
        end_user: "決済システム利用者",
        remarks: "AES256導入と鍵管理設計を実施",
      },
      {
        id: "5",
        sequence_num: 5,
        skill_type: 3,
        industry: "ITサービス",
        system_name: "セキュリティポリシー策定支援",
        system_detail: "社内情報セキュリティ基本方針の作成と運用設計",
        assigned_task: "ポリシー文書作成・承認プロセス支援",
        work_contents: [{ id: 2, name: "基本設計" }],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "ISMS推進チーム",
        member_count: "6",
        env1: "Microsoft SharePoint",
        env2: "承認履歴の記録",
        env3: "ポリシー文書",
        env4: "",
        env5: "",
        work_start_period: "2024-01",
        work_end_period: "2024-12",
        period_year: 1,
        period_month: 0,
        client: "ITベンダーD",
        end_user: "全社職員",
        remarks: "ISO27001をベースに作成",
      },
    ],
  };

  const testTechFolioInfra: TechFolio = {
    id: "2",
    specialty: `AWS、Azureを用いたクラウド環境の構築やLinux/Windows基盤のセットアップ、ミドルウェア構成、Zabbix・JP1等の運用監視環境構築。Ansibleを用いた自動化運用の経験もあり。`,
    tech_experiences: [
      {
        id: "1",
        sequence_num: 1,
        skill_type: 2,
        industry: "製造業",
        system_name: "AWS移行プロジェクト",
        system_detail: "オンプレからAWS環境へ基盤を移行し、運用設計を実施",
        assigned_task: "VPC設計・IAM設定・監視設定",
        work_contents: [
          { id: 1, name: "要件定義" },
          { id: 7, name: "基本・詳細設計" },
        ],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "4",
        env1: "AWS", // 基盤環境
        env2: "EC2・RDS・WAF・ECS・Fargate・CloudWatch", // クラウド
        env3: "Docker", // OS基盤
        env4: "Apache・PHP・MySQL", // MW構成
        env5: "Terraform・Zabbix・CodeDeploy", // 運用監視
        work_start_period: "2022-01",
        work_end_period: "2022-08",
        period_year: 0,
        period_month: 8,
        client: "製造業X",
        end_user: "社内情報システム部門",
        remarks: "CloudTrailによる監査ログ設計も担当",
      },
      {
        id: "2",
        sequence_num: 2,
        skill_type: 2,
        industry: "金融",
        system_name: "Azure仮想化基盤構築",
        system_detail: "オンプレからAzureへのLift&Shift移行",
        assigned_task: "ネットワーク設計とAzure Policy導入",
        work_contents: [
          { id: 2, name: "基本設計" },
          { id: 5, name: "システムテスト" },
        ],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "5",
        env1: "Azure", // 基盤環境
        env2: "Azure VM / AppService", // クラウド
        env3: "Windows Server 2019", // OS基盤
        env4: "PowerShell DSC", // MW構成
        env5: "CloudWatch", // 運用監視
        work_start_period: "2021-04",
        work_end_period: "2021-12",
        period_year: 0,
        period_month: 9,
        client: "証券会社Y",
        end_user: "業務部門",
        remarks: "Azure Advisor提案の自動化も実装",
      },
      {
        id: "3",
        sequence_num: 3,
        skill_type: 2,
        industry: "",
        system_name: "",
        system_detail:
          "アイソプラへ転職する前に、他社でIT関連の業務をやっていた場合は記載。",
        assigned_task: "",
        work_contents: [],
        position_id: null,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "",
        env1: "",
        env2: "",
        env3: "",
        env4: "",
        env5: "",
        work_start_period: "2021-01",
        work_end_period: "2021-12",
        period_year: 1,
        period_month: 0,
        client: "",
        end_user: "",
        remarks: "",
      },
      {
        id: "4",
        sequence_num: 4,
        skill_type: 2,
        industry: "通信",
        system_name: "物理サーバー構築",
        system_detail:
          "ラックマウント・OSセットアップ・RAID構成・IP設定等を対応",
        assigned_task: "現地設置作業と初期構築",
        work_contents: [
          { id: 8, name: "調査分析" },
          { id: 2, name: "基本設計" },
        ],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "PJTチーム",
        member_count: "3",
        env1: "オンプレミス", // 基盤環境
        env2: "", // クラウド
        env3: "RHEL 8.5", // OS基盤
        env4: "Ansible", // MW構成
        env5: "JP1/AJS3", // 運用監視
        work_start_period: "2020-07",
        work_end_period: "2020-12",
        period_year: 0,
        period_month: 6,
        client: "大手通信会社C",
        end_user: "NWインフラ部門",
        remarks: "HDD障害検知・冗長構成のテストも担当",
      },
      {
        id: "5",
        sequence_num: 5,
        skill_type: 2,
        industry: "流通",
        system_name: "統合監視環境構築",
        system_detail: "複数拠点のシステムをZabbixで集中監視",
        assigned_task: "監視サーバー設計・しきい値設定・通知テスト",
        work_contents: [
          { id: 4, name: "結合テスト" },
          { id: 5, name: "システムテスト" },
        ],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "4",
        env1: "オンプレミス", // 基盤環境
        env2: "", // クラウド
        env3: "Ubuntu 20.04 LTS", // OS基盤
        env4: "ShellScript / Python", // MW構成
        env5: "Zabbix 6.0", // 運用監視
        work_start_period: "2023-01",
        work_end_period: "2023-05",
        period_year: 0,
        period_month: 5,
        client: "物流会社B",
        end_user: "全国の物流拠点運用部",
        remarks: "リモート監視対応やトラップ通知も設計",
      },
    ],
  };

  const testTechFolioDesigner: TechFolio = {
    id: "3",
    specialty: `PhotoshopやFigmaを使用したUI/UXデザイン、HTML+CSSコーディング経験あり。ロゴ制作、パンフレットデザイン、プロトタイプ作成も対応。`,
    tech_experiences: [
      {
        id: "1",
        sequence_num: 1,
        skill_type: 4,
        industry: "IT",
        system_name: "モバイルバンキングアプリUI設計",
        system_detail: "ユーザーインタビューを元にUI/UXデザインをFigmaで作成",
        assigned_task: "ワイヤーフレーム作成・プロトタイプ設計",
        work_contents: [{ id: 6, name: "画面設計" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "UXデザインチーム",
        member_count: "4",
        env1: "Windows",
        env2: "Figma, Adobe XD",
        env3: "Illustrator, Photoshop",
        env4: "Slack, Notion",
        env5: "Chrome DevTools",
        work_start_period: "2021-03",
        work_end_period: "2021-09",
        period_year: 0,
        period_month: 7,
        client: "都市銀行A",
        end_user: "スマホ利用者",
        remarks: "ユーザビリティテスト実施",
      },
      {
        id: "2",
        sequence_num: 2,
        skill_type: 4,
        industry: "教育",
        system_name: "EラーニングプラットフォームUI改善",
        system_detail: "既存サービスのUX課題抽出と画面デザイン改善",
        assigned_task: "ヒューリスティック分析・UIガイドライン作成",
        work_contents: [{ id: 8, name: "調査分析" }],
        position_id: 1,
        position: { id: "1", name: "PG" },
        team: "UX推進チーム",
        member_count: "3",
        env1: "MacOS",
        env2: "Figma",
        env3: "Photoshop, Zeplin",
        env4: "Jira",
        env5: "Confluence",
        work_start_period: "2022-05",
        work_end_period: "2022-12",
        period_year: 0,
        period_month: 8,
        client: "教育会社B",
        end_user: "学習者・講師",
        remarks: "ABテスト設計・改善効果の分析を実施",
      },
      {
        id: "3",
        sequence_num: 3,
        skill_type: 4,
        industry: "",
        system_name: "",
        system_detail:
          "アイソプラへ転職する前に、他社でIT関連の業務をやっていた場合は記載。",
        assigned_task: "",
        work_contents: [],
        position_id: null,
        position: { id: "2", name: "SE" },
        team: "PJTチーム",
        member_count: "",
        env1: "",
        env2: "",
        env3: "",
        env4: "",
        env5: "",
        work_start_period: "2021-01",
        work_end_period: "2021-12",
        period_year: 1,
        period_month: 0,
        client: "",
        end_user: "",
        remarks: "",
      },
      {
        id: "4",
        sequence_num: 4,
        skill_type: 4,
        industry: "小売",
        system_name: "ブランドECサイト新規構築",
        system_detail: "PC/SP対応のUIデザイン・商品画像編集などを担当",
        assigned_task: "デザインカンプ作成・レスポンシブ対応",
        work_contents: [{ id: 2, name: "基本設計" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "デザインチーム",
        member_count: "5",
        env1: "Windows",
        env2: "Photoshop, HTML5",
        env3: "CSS3, JavaScript",
        env4: "VSCode",
        env5: "Chrome",
        work_start_period: "2020-01",
        work_end_period: "2020-06",
        period_year: 0,
        period_month: 6,
        client: "アパレル企業C",
        end_user: "ECサイト利用者",
        remarks: "商品画像の切り抜き・バナー制作も対応",
      },
      {
        id: "5",
        sequence_num: 5,
        skill_type: 4,
        industry: "広告",
        system_name: "企業コーポレートサイトリニューアル",
        system_detail: "ビジュアル重視のトップページデザイン作成",
        assigned_task: "ビジュアルデザイン・ロゴ提案・アイコン作成",
        work_contents: [{ id: 6, name: "画面設計" }],
        position_id: 2,
        position: { id: "2", name: "SE" },
        team: "ブランディングチーム",
        member_count: "6",
        env1: "MacOS",
        env2: "Illustrator, Photoshop",
        env3: "Sketch",
        env4: "Slack",
        env5: "Git",
        work_start_period: "2019-06",
        work_end_period: "2019-12",
        period_year: 0,
        period_month: 7,
        client: "広告代理店D",
        end_user: "企業サイト訪問者",
        remarks: "色彩設計とトンマナ定義も実施",
      },
    ],
  };

  const getLabelsBySkillType = (skill_type: number): string[] => {
    switch (skill_type) {
      case 1:
        return ["ServerOS", "MW/ツール", "開発言語", "DB", "開発環境"];
      case 2:
        return ["基盤環境", "クラウド", "OS基盤", "MW構成", "運用監視"];
      case 3:
        return ["対象製品/サービス", "管理方法", "管理対象"];
      case 4:
        return ["ServerOS", "MW/ツール", "開発言語", "PJ管理", "開発環境"];
      default:
        return ["環境1", "環境2", "環境3", "環境4", "環境5"];
    }
  };

  useEffect(() => {
    // テストデータ定義
    const testUser: User = {
      id: 1,
      last_name: "山田",
      first_name: "太郎",
      last_name_en: "Yamada",
      first_name_en: "Taro",
      name_ini: "TY",
      name: "山田 太郎",
      name_en: "Yamada Taro",
      nationality: "日本",
      gender: "男性",
      age: 30,
      birth_date: "1994-01-01",
      current_address: "東京都港区",
      qualifications: [
        {
          id: "1",
          name: "基本情報技術者",
          pivot: { qualification_id: 1, qualification_get_date: "2015-04" },
        },
        {
          id: "2",
          name: "応用情報技術者",
          pivot: { qualification_id: 2, qualification_get_date: "2016-06" },
        },
        {
          id: "3",
          name: "ネットワークスペシャリスト",
          pivot: { qualification_id: 3, qualification_get_date: "2018-10" },
        },
      ],
      sheets: { updated_at: "2024-01-01" },
      isSelected: false,
      isTarget: false,
    };

    const testQualificationOptions: SelectOption[] = [
      { id: 1, name: "基本情報技術者" },
      { id: 2, name: "応用情報技術者" },
    ];

    const testWorkContentOptions: SelectOption[] = [
      { id: 1, name: "要件定義" },
      { id: 2, name: "基本設計" },
      { id: 3, name: "ＣＤ・ＵＴ" },
      { id: 4, name: "結合テスト" },
      { id: 5, name: "システムテスト" },
      { id: 6, name: "画面設計" },
      { id: 7, name: "基本・詳細設計" },
      { id: 8, name: "調査分析" },
    ];

    const testPositionOptions: SelectOption[] = [
      { id: 1, name: "PG" },
      { id: 2, name: "SE" },
    ];

    const formattedQualifications: Qualification[] =
      testUser.qualifications?.map((q) => ({
        id: q.id,
        qualification_id: q.pivot.qualification_id.toString(),
        name: q.name,
        get_date: q.pivot.qualification_get_date,
        isDisplay: true,
      })) ?? [];

    setUser(testUser);
    setQualifications(formattedQualifications);
    setQualificationOptions(testQualificationOptions);
    setWorkContentOptions(testWorkContentOptions);
    setPositionOptions(testPositionOptions);
    setTechFolio(testTechFolioApp);
  }, []);

  // work_end_periodが未来の日付かどうか
  const isPlaned = (idx: number) => {
    // 年月形式の文字列を "YYYY-MM-01" の形式に変換
    const current = new Date();
    const end = new Date(
      techFolio?.tech_experiences?.[idx - 1].work_end_period + "-01",
    );

    return end > current;
  };

  // 開始日と終了日から期間を計算
  const calculatePeriod = (idx: number) => {
    // 年月形式の文字列を "YYYY-MM-01" の形式に変換
    const start = new Date(
      techFolio?.tech_experiences?.[idx - 1].work_start_period + "-01",
    );
    const end = new Date(
      techFolio?.tech_experiences?.[idx - 1].work_end_period + "-01",
    );

    // 差をミリ秒で計算し、月数に変換
    const diffTime: number = end.getTime() - start.getTime(); // 明示的に number 型として計算
    const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30); // 月単位の差

    // 月数から年と月を計算
    const years = Math.floor(diffMonths / 12);
    const months = Math.round(diffMonths % 12);

    return `${years}年 ${months}ヶ月`;
  };

  // 開始日と終了日から期間を計算
  const calculateBirthDate = (date: string) => {
    return new Date(date).toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Layout>
      <div className="p-10 bg-white rounded-3xl">
        <div className="flex mb-4">
          <div className="title-text font-black">スキルシート</div>
        </div>
        <div>
          <div className="flex mb-6 space-x-20">
            {/* プロフィールテーブル */}
            <div className="min-w-[20rem]">
              <div className="flex mb-4">
                <div className="rounded-full mt-1.5 border-slate-100 mr-3 w-5 h-5 title-circle"></div>
                <div className="text-lg text-slate-500 font-black">
                  プロフィール
                </div>
              </div>
              <div className="border-2 border-slate-300 rounded-2xl inline-block overflow-x-auto">
                <table className="min-w-[30rem] table-auto w-auto text-slate-600 border-collapse">
                  <tbody>
                    <tr>
                      <th className="w-32 bg-slate-100 px-4 py-2 text-right border-r-2">
                        氏名
                      </th>
                      <td className="bg-white  px-4 py-2">
                        {user ? `${user.name}` : "データがありません"}
                      </td>
                    </tr>
                    <tr>
                      <th className="bg-eaf0f6 px-4 py-2 text-right border-r-2">
                        ローマ字
                      </th>
                      <td className="bg-slate-50  px-4 py-2">
                        {user ? user.name_en : "データなし"}
                      </td>
                    </tr>
                    <tr>
                      <th className="bg-slate-100 px-4 py-2 text-right border-r-2">
                        国籍
                      </th>
                      <td className="bg-white  px-4 py-2">
                        {user ? user.nationality : "データなし"}
                      </td>
                    </tr>
                    <tr>
                      <th className="bg-eaf0f6 px-4 py-2 text-right border-r-2">
                        性別
                      </th>
                      <td className="bg-slate-50  px-4 py-2">
                        {user ? user.gender : "データなし"}
                      </td>
                    </tr>
                    {/* <tr>
                        <th className="bg-slate-100 px-4 py-2 text-right border-r-2">
                          年齢
                        </th>
                        <td className="bg-white  px-4 py-2">
                          {user ? user.age : "データなし"}
                        </td>
                      </tr> */}
                    <tr>
                      <th className="bg-slate-100 px-4 py-2 text-right border-r-2">
                        生年月日
                      </th>
                      <td className="bg-white  px-4 py-2">
                        {user
                          ? calculateBirthDate(user.birth_date)
                          : "データなし"}
                      </td>
                    </tr>
                    <tr>
                      <th className="bg-eaf0f6 px-4 py-2 text-right border-r-2">
                        現住所
                        <br />
                      </th>
                      <td className="bg-slate-50 px-2 py-2">
                        <input
                          type="text"
                          disabled
                          readOnly
                          value={user ? user.current_address : ""}
                          className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* 保有資格テーブル */}
            <div className="min-w-[40rem]">
              <div className="flex mb-4">
                <div className="rounded-full mt-1.5 border-slate-100 mr-3 w-5 h-5 title-circle"></div>
                <div className="text-lg text-slate-500 font-black">
                  保有資格
                </div>
              </div>
              <div className="border-2 border-slate-300 rounded-2xl inline-block overflow-x-auto">
                <table className="min-w-[30rem] table-auto w-auto text-slate-600 border-collapse">
                  <thead className="border-b-2">
                    <tr>
                      <th className="bg-slate-100 px-4 py-2 border-r-2">
                        項番
                      </th>
                      <th className="bg-slate-100 px-4 py-2 border-r-2">
                        資格名称
                      </th>
                      <th className="bg-slate-100 px-4 py-2 border-r-2">
                        取得年月
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {qualifications.map((qualification, idx) => (
                      <tr key={idx}>
                        <td
                          className={`${
                            idx % 2 === 0 ? "bg-slate-100" : "bg-eaf0f6"
                          } px-4 py-2 text-center border-r-2`}
                        >
                          {idx + 1}
                        </td>
                        <td
                          className={`${
                            idx % 2 === 0 ? "bg-white" : "bg-slate-50"
                          } px-4 py-2 border-r-2`}
                        >
                          <input
                            type="text"
                            value={qualification.name || ""}
                            disabled
                            readOnly
                            className="w-full border-2 border-slate-300 px-2 py-1 rounded bg-gray-100 text-gray-700"
                          />
                        </td>
                        <td
                          className={`${
                            idx % 2 === 0 ? "bg-white" : "bg-slate-50"
                          } px-4 py-2 border-r-2`}
                        >
                          <input
                            type="month"
                            value={
                              qualification.get_date
                                ? qualification.get_date.slice(0, 7)
                                : ""
                            }
                            disabled
                            readOnly
                            className="border border-gray-300 rounded p-2 bg-gray-100 text-gray-700"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* 得意分野 */}
          <div className="mb-6">
            <div className="flex mb-4">
              <div className="rounded-full mt-1.5 border-slate-100 mr-3 w-5 h-5 title-circle"></div>
              <div className="text-lg text-slate-500 font-black">得意分野</div>
            </div>
            <textarea
              placeholder="入力してください"
              disabled
              readOnly
              className="h-[10em] w-[800px] p-3 resize-none border-2 border-slate-300 rounded-2xl"
              value={techFolio?.specialty}
            />
          </div>
          {/* 技術経験テーブル */}
          <div className="mb-6">
            <div className="flex mb-4 items-center justify-between">
              <div className="flex">
                <div className="rounded-full mt-1.5 border-slate-100 mr-3 w-5 h-5 title-circle"></div>
                <div className="text-lg text-slate-500 font-black">
                  経験プロジェクト
                </div>
              </div>
              <div className="ml-4 text-sm">
                <span className="mr-2 text-slate-400 font-black">表示:</span>
                <div className="inline-flex border border-gray-300 rounded-full overflow-hidden">
                  {[
                    { label: "アプリ", type: 1 },
                    { label: "インフラ", type: 2 },
                    { label: "セキュリティ", type: 3 },
                    { label: "デザイナー", type: 4 },
                  ].map(({ label, type }) => (
                    <label
                      key={type}
                      className={`px-4 py-1 cursor-pointer transition-all duration-200 ${
                        techFolio?.tech_experiences?.[0]?.skill_type === type
                          ? "bg-iso text-white"
                          : "bg-white text-slate-600 hover:bg-gray-100"
                      }`}
                    >
                      <input
                        type="radio"
                        name="mode"
                        value={type}
                        checked={
                          techFolio?.tech_experiences?.[0]?.skill_type === type
                        }
                        onChange={() => {
                          switch (type) {
                            case 1:
                              setTechFolio(testTechFolioApp);
                              break;
                            case 2:
                              setTechFolio(testTechFolioInfra);
                              break;
                            case 3:
                              setTechFolio(testTechFolioSecurity);
                              break;
                            case 4:
                              setTechFolio(testTechFolioDesigner);
                              break;
                          }
                        }}
                        className="hidden"
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="tech-exp-wrap w-full border-2 border-slate-300 rounded-2xl bg-white">
              <div className="overflow-visible">
                <table className="tech-exp-table table-auto text-slate-600 w-full border-collapse">
                  <thead className="border-b-2">
                    <tr>
                      <th className="bg-[rgb(234_240_246)] px-2 py-2 border-r-2 border-r-2 w-16">
                        項番
                      </th>
                      <th className="bg-[rgb(234_240_246)] px-2 py-2 border-r-2 border-r-2 min-w-60">
                        担当作業・作成プログラム等
                      </th>
                      <th className="bg-[rgb(234_240_246)] px-2 py-2 border-r-2 border-r-2 w-56">
                        作業内容
                      </th>
                      <th className="bg-[rgb(234_240_246)] px-2 py-2 border-r-2 border-r-2 w-44">
                        参加形態
                      </th>
                      <th className="bg-[rgb(234_240_246)] px-2 py-2 border-r-2 border-r-2 w-60">
                        環境
                      </th>
                      <th className="bg-[rgb(234_240_246)] px-2 py-2 border-r-2 border-r-2 w-36">
                        作業期間
                      </th>
                      <th className="bg-[rgb(234_240_246)] px-2 py-2 border-r-2 border-r-2 min-w-40">
                        補足事項
                        <br />
                        （印刷対象外）
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {techFolio?.tech_experiences?.map(
                      (techExperience, index) => (
                        <tr key={techExperience.sequence_num}>
                          <td
                            className={`${
                              index % 2 === 0 ? "bg-slate-100" : "bg-eaf0f6"
                            } px-4 py-2 text-center border-r-2`}
                          >
                            <div className="flex flex-col items-center justify-center h-full">
                              <span className="mt-auto">
                                {techExperience.sequence_num}
                              </span>
                            </div>
                          </td>
                          <td
                            className={`${
                              index % 2 === 0 ? "bg-white" : "bg-slate-50"
                            } px-4 py-2 border-r-2 align-top min-w-80`}
                          >
                            <div>
                              <strong>業界</strong>
                              <input
                                type="text"
                                disabled
                                readOnly
                                value={techExperience.industry}
                                className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                                placeholder="入力してください"
                              />
                            </div>
                            <div>
                              <strong>プロジェクト名</strong>
                              <input
                                disabled
                                readOnly
                                type="text"
                                value={techExperience.system_name}
                                className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                                placeholder="入力してください"
                              />
                            </div>
                            <div>
                              <strong>システム概要</strong>
                              <textarea
                                value={techExperience.system_detail}
                                disabled
                                readOnly
                                className={`w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300 ${
                                  index === 2 ? "text-red-600" : ""
                                }`}
                                placeholder="入力してください"
                              />
                            </div>
                            <div>
                              <strong>担当業務</strong>
                              <input
                                type="text"
                                disabled
                                readOnly
                                value={techExperience.assigned_task}
                                className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                                placeholder="入力してください"
                              />
                            </div>
                          </td>
                          <td
                            className={`${
                              index % 2 === 0 ? "bg-white" : "bg-slate-50"
                            } px-4 py-2 border-r-2 align-top`}
                          >
                            {techExperience.work_contents?.map(
                              (content, idx) => {
                                const selectedOption = workContentOptions.find(
                                  (opt) => opt.id === content.id,
                                );
                                return (
                                  <div className="pb-2" key={idx}>
                                    <input
                                      disabled
                                      readOnly
                                      type="text"
                                      value={selectedOption?.name || ""}
                                      className="w-full border-2 border-slate-300 px-2 py-1 rounded bg-slate-100 text-slate-700"
                                    />
                                  </div>
                                );
                              },
                            )}
                          </td>
                          <td
                            className={`${
                              index % 2 === 0 ? "bg-white" : "bg-slate-50"
                            } px-4 py-2 border-r-2 align-top`}
                          >
                            <div>
                              <strong>役割</strong>
                              <input
                                type="text"
                                disabled
                                value={
                                  positionOptions.find(
                                    (opt) =>
                                      opt.id === techExperience.position_id,
                                  )?.name || ""
                                }
                                readOnly
                                className="w-full border-2 border-slate-300 px-2 py-1 rounded bg-slate-100 text-slate-700"
                              />
                            </div>
                            {/* 
                          <div>
                            <strong>チーム</strong>
                            <input
                              type="text"
                              disabled
                              readOnly
                              value={techExperience.team}
                              className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                              placeholder="入力してください"
                            />
                          </div>
                          */}
                            <div>
                              <strong>PJTチーム</strong>
                              <input
                                disabled
                                readOnly
                                type="number"
                                min="1"
                                step="1"
                                value={techExperience.member_count}
                                className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                              />
                            </div>
                          </td>
                          <td
                            className={`${
                              index % 2 === 0 ? "bg-white" : "bg-slate-50"
                            } px-4 py-2 border-r-2 align-top`}
                          >
                            {getLabelsBySkillType(
                              techExperience.skill_type,
                            ).map((label, i) => {
                              const envKey = `env${
                                i + 1
                              }` as keyof typeof techExperience;
                              const value = techExperience[envKey];

                              return (
                                <div key={i}>
                                  <strong className="inline-block">
                                    {label}
                                  </strong>
                                  <input
                                    type="text"
                                    disabled
                                    readOnly
                                    value={
                                      typeof value === "string" ||
                                      typeof value === "number"
                                        ? value
                                        : ""
                                    }
                                    className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                                  />
                                  <br />
                                </div>
                              );
                            })}
                          </td>
                          <td
                            className={`${
                              index % 2 === 0 ? "bg-white" : "bg-slate-50"
                            } px-4 py-2 border-r-2 align-top`}
                          >
                            <div className="my-1">
                              <strong>開始</strong>：
                            </div>
                            <div className="my-1">
                              <input
                                type="month"
                                disabled
                                readOnly
                                value={techExperience.work_start_period}
                                className="border border-gray-300 rounded p-2"
                              />
                            </div>
                            <div className="my-1">
                              <strong>
                                終了
                                {isPlaned(techExperience.sequence_num) &&
                                  "予定"}
                              </strong>
                              ：
                            </div>
                            <div className="my-1">
                              <input
                                type="month"
                                disabled
                                readOnly
                                value={techExperience.work_end_period}
                                className="border border-gray-300 rounded p-2"
                              />
                            </div>
                            <div className="my-1">
                              <strong>期間</strong>：
                            </div>
                            <div className="my-1">
                              {calculatePeriod(techExperience.sequence_num)}
                            </div>
                          </td>
                          <td
                            className={`${
                              index % 2 === 0 ? "bg-white" : "bg-slate-50"
                            } px-4 py-2 border-r-2 align-top max-w-32`}
                          >
                            <strong>取引先</strong>
                            <input
                              type="text"
                              disabled
                              readOnly
                              value={techExperience.client}
                              className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                            />
                            <strong>エンドユーザー</strong>
                            <input
                              type="text"
                              disabled
                              readOnly
                              value={techExperience.end_user}
                              className="w-full border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                            />
                            {/* <strong>備考</strong>：
                          <textarea
                            value={techExperience.remarks}
                            disabled
                            readOnly
                            className="w-full min-h-24 border-2 border-slate-300 px-2 py-1 rounded focus:outline-none focus:ring focus:border-blue-300"
                          /> */}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MySheet;
